import Vue from 'vue'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

Vue.component('clip-loader', ClipLoader)
